import { NotificationManager } from 'react-notifications';

const delay_success_time = 3000;
const delay_warning_time = 3000;
const delay_error_time = 3000;
class Alerts {
  info = (message) => {
    NotificationManager.info(message);
  };

  success = (message, title, time = delay_success_time) => {
    NotificationManager.success(message, title, time);
  };

  warning = (message, title, time = delay_warning_time) => {
    NotificationManager.warning(message, title, time);
  };

  error = (message, title, time = delay_error_time) => {
    NotificationManager.error(message, title, time);
  };
}

const alerts = new Alerts();
export { alerts };
